// Shared by hotspotConfig (frontend) and exportService (backend).

export const AGE_CLASS_LABELS: Record<string, string> = {
  hot: 'Hot (<12h)',
  warm: 'Warm (12-24h)',
  cold: 'Cold (>24h)',
};

export const SOURCE_LABELS: Record<string, string> = {
  noaa20: 'NOAA-20',
  noaa21: 'NOAA-21',
  snpp: 'Suomi-NPP',
};

export const CONFIDENCE_LABELS: Record<string, string> = {
  h: 'High',
  n: 'Nominal',
  l: 'Low',
};
